<template lang="pug">
    tr

        // Date created
        td {{ item.createdAt | formattedDate }}

        // Business Name
        td {{ item.title }}

        // Actions
        td.text-xs-right(class="justify-center px-0 actions")

            slot
</template>

<script>
    import VueTypes from 'vue-types';
    import formattedDate from '~filters/FormattedDate';
    import ListItemActions from './ListItemActions';

    export default {
        components: {
            ItemActions: ListItemActions
        },
        filters: {
            formattedDate
        },
        props: {
            item: VueTypes.object.def({})
        }
    };
</script>

<style lang="stylus" scoped>
    .role
        text-transform: capitalize
</style>
